export default {
    '登录':'Log in',
    '忘记密码':'Forgot password',
    '联系客服':'CUSTOMER SERVICE',
    '欢迎登录':'Welcome to login',
    '还没有账号':'No account yet',
    '去注册':'Go to register',
    '首页': 'Home',
    '公益榜': 'Public welfare',
    '反诈': 'Anti-fraud',
    '我的': 'Mine',
    '注册': 'Register',
    '切换登录': 'Switch login',
    '有账号':'Have an account',
    '用户注册':'User registration',
    '请输入账号':'Please enter your login account',
    '请输入手机号':'Please enter your mobile phone number',
    '请再次输入密码': 'Please enter your password again',
    '请输入真实姓名': 'Please enter your real name',
    '请输入密码':'Please enter your password',
    '热搜榜': 'Hot search list',
    '关于我们': 'About us',
    '我要参与': 'I want to participate',
    '新闻动态': 'News',
    '下载': 'Download',
    '联系我们': 'Contact us',
    '字节跳动公益':'ByteDance Public Welfare',
    '字節跳動公益':'ByteDance Public Welfare',
    '我们是谁':'Who are we',
    '我们做什么':'What we do',
    '为了更美好的生活':'For a Better Life',
    '北京市': 'Beijing',
    '海淀北二街10号': 'No.10 Haidian North 2nd Street',
    '9层0902室': 'Room 0902, 9th Floor',
    '抖音热榜': 'TikTok Hot',
    '音乐榜': 'Music',
    '电影榜': 'Movie',
    '财经榜': 'Financial',
    '直播榜': 'Live',
    '最新': 'New',
    '推荐': 'Recommend',
    '银行卡账号': 'Bank card account',
    '姓名': 'Name',
    '预留手机号': 'Reserved mobile phone number',
    '开户行': 'Bank of deposit',
    '提交资料': 'Submit information',
    '请输入': 'Please enter',
    '卡号': 'Card number',
    '银行预留手机号': 'Bank reserved mobile phone number',
    '当前账户余额': 'Current account balance',
    '请绑定提现银行卡': 'Please bind the withdrawal bank card',
    '提现密码': 'Withdrawal password',
    '提交申请': 'Submit application',
    '温馨提示': 'Warm prompt',
    '提现时间': 'Withdrawal time',
    '余额': 'Balance',
    '立即提现': 'Withdraw now',
    '去充值': 'Go to recharge',
    '抖音商城': 'TikTok Mall',
    '美好生活触手可得': 'A good life is at your fingertips',
    '安全中心': 'Security center',
    '财务信息请妥善保管': 'Please keep your financial information properly',
    '助力记录': 'Help record',
    '交易记录': 'Transaction record',
    '金额': 'Amount',
    '变动时间': 'Change time',
    '点击加载更多': 'Click to load more',
    '修改提现密码': 'Modify withdrawal password',
    '银行卡': 'Bank card',
    '退出登录': 'Sign out',
    '请输入提现密码,新用户默认登录密码': 'Please enter the withdrawal password, the new user defaults to the login password',
    '截止参与': 'Deadline for participation',
    '截止开奖': 'Deadline for lottery',
    '期': 'Phase',
    '已捐款':'Donated',
    '捐款次数':'Frequency',
    '我的捐款': 'My donation',
    '邀请好友参加':'Invite friends to participate',
    '立即捐赠':'Donate Now',
    '跳过': 'Skip',
    '我已知晓': 'I already know',
    '成就生命的美好': 'Achieve the beauty of life',
    '山里都是好风光': 'Beautiful scenery in the mountains',
    '依托当地特色文旅资源打造品牌，助力文旅扶贫': 'Relying on local characteristic cultural and tourism resources to create a brand and assist in poverty alleviation',
    '字節跳動公益基金会定制愿景与使命的目的是希望“通过提升个体的智力，体力和财力”使其能够实现自己的生命价值。': 'The purpose of ByteDance Public Welfare Foundation\'s customized vision and mission is to enable individuals to realize their life value "by improving their intelligence, physical strength and financial resources".',
    '4.46亿元，为抗击疫情一线医务工作者提供保障': '446 million yuan, providing security for front-line medical workers fighting the epidemic',
    '字节跳动医务救助基金投入':'ByteDance Medical Aid Fund Investment',
    '字節跳動公益医务救助基金投入':'ByteDance Public Welfare Medical Aid Fund Investment',
    '抖音非遗合伙人播放':'TikTok Intangible Cultural Heritage Partner Plays',
    '山货上头条助销农产品':'Headline Helps Sell Agricultural Products',
    '头条寻人找到':'Headlines People Search Found',
    '医疗健康':'Healthcare',
    '字节跳动医务基金': 'ByteDance Medical Fund',
    '字节跳动医务基金为抗击疫情一线医务工作者提供保障，目前基金总额为4.46亿元。':'The ByteDance medical fund provides security for front-line medical workers in the fight against the epidemic, with a total fund of 446 million yuan.',
    '2020 字节跳动基金会京公网安备 11000002002068号 京ICP备12025439号-7':'2020 ByteDance Foundation Beijing Public Network Security No. 11000002002068 Beijing ICP No. 12025439-7',
    '字节跳动基金会京公网安备11000002002068号': 'ByteDance Foundation Beijing Public Network Security No. 11000002002068',
    '京ICP备12025439号':'Beijing ICP No. 12025439',
    '收款银行': 'Receiving bank',
    '收款人账号':'Payee account',
    '收款人姓名':'Name of payee',
    '红队赔率':'Red team odds',
    '蓝队赔率':'Blue team odds',
    '元':'Yuan',
    '次':'Times',
    '人':'People',
}
